import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from 'src/toolkit/services/AuthProvider';
import routerPaths from 'src/integration/config/routerPaths';
import useFetchProfile from 'src/integration/api/useFetchProfile';

const PrivateRoute = () => {
  const { token } = useAuth();
  const { isLoading } = useFetchProfile();

  if (!token) return <Navigate to={routerPaths.login()} />;

  if (isLoading && token) {
    return (
      <></>
    )
  }

  return <Outlet />;
};

export default PrivateRoute;